import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function BOFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-rk0oe4axi" fill="#fff">
            <path fillRule="evenodd" d="M0 0h32v24H0z" />
          </mask>
          <mask id="mantine-kpqydxla9" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-p98t7gndk" />
          </mask>
          <mask id="mantine-bufyciiu3" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-u8fps9l1o" />
          </mask>
          <ellipse id="mantine-u8fps9l1o" cx="1.854" cy="2.09" rx="1.854" ry="2.09" />
          <path id="mantine-p98t7gndk" d="M0 0h32v24H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-rk0oe4axi)">
          <use fill="#feca00" xlinkHref="#mantine-p98t7gndk" />
          <path fill="#db501c" d="M0 0h32v8H0z" mask="url(#mantine-kpqydxla9)" />
          <path fill="#5eaa22" d="M0 16h32v8H0z" mask="url(#mantine-kpqydxla9)" />
          <g mask="url(#mantine-kpqydxla9)">
            <g fillRule="nonzero">
              <path fill="#864c26" d="M12.446 9.96l.036-.036 7.22 6.945-.036.035z" />
              <path fill="#864c26" d="M20.221 16.417l-.03.04-8.4-6.17.031-.04z" />
              <path fill="#a05a2c" d="M20.398 15.802l-.025.043-9.343-5.086.025-.043z" />
              <path
                fill="#e7e7e7"
                d="M10 10.184l.805.27-.232.268zm.767.073l.115.104c.183.166.24.304.162.412-.077.106-.236.126-.475.068l-.097-.024.097-.024a.62.62 0 00.195-.082l-.04-.001c-.05 0-.092-.033-.124-.095l-.03.034-.368-.345.515.173h-.002l.033.008c.026.006.054.014.083.023.023.007.04.017.053.032a.276.276 0 00-.042-.15zm-.014-.616l.778.338-.036.034.058.022a.116.116 0 01.049.036.27.27 0 00-.028-.151l-.063-.14.106.113c.167.182.212.325.125.425-.086.099-.247.105-.48.026l-.094-.032.099-.016a.619.619 0 00.202-.065l-.041-.004c-.036-.003-.066-.023-.09-.058l-.06.058zm.849-.529l.707.468-.04.027.05.03a.104.104 0 01.043.046.282.282 0 00-.002-.156l-.037-.15.084.131c.134.208.153.356.05.44-.102.082-.261.061-.476-.057l-.088-.048.1.001a.62.62 0 00.21-.028l-.04-.012a.119.119 0 01-.077-.07l-.07.046z"
              />
            </g>
            <g transform="translate(10.927 9.239)">
              <path fill="#925229" d="M2.544 6.974l.835-1.488 1.17.315-.842 1.359H3.38v.148z" />
              <path
                fill="#ffe000"
                d="M2.186 1.25l-.552.574-.201 3.794 1.99.29c-.578-.507-.91-.918-.995-1.231-.128-.47-.168-2.225.074-2.492l.189.11.152-.451"
              />
              <path
                fill="#d52c1e"
                d="M.262 1.509C.12 3.484.048 4.645.048 4.992c0 .52.442 1.759 1.449 1.759s2.389-.554 2.389-.78c0-.151-.138-.28-.413-.389-1.234.085-1.852-.112-1.852-.59 0-.718.126-2.842.236-3.092.073-.167.237-.376.491-.628l-.727-.54-.124.54-.466-.159-.142.787z"
              />
              <path
                fill="#027934"
                d="M2.85 1.837l-.134.42-.27-.115c-.27 1.264-.27 2.161 0 2.69.269.53.743.814 1.422.853l-.43-3.429z"
              />
              <path
                fill="#e8a30c"
                d="M2.79 4.4l-.97.767c-.178.254-.178.478 0 .67.266.29 1.004.584 1.178.235.116-.233.346-.485.691-.757z"
              />
              <circle
                cx="3.389"
                cy="1.316"
                r="1"
                fill="#e1e5e8"
                transform="rotate(-41 3.389 1.316)"
              />
              <path
                fill="#d52c1e"
                d="M2.956.065a3.072 3.072 0 00-.138-.026c-.307-.047-.46.016-.46.187 0 .294.195.611.195.833s.01.567.104.394c.063-.115.254-.345.573-.691l-.274-.45c.453.05.58.022.381-.086"
              />
            </g>
            <path
              fill="#d52c1e"
              d="M15.97 15.378l-.51-.005c-.377.374-.412.877-.114 1.484.065.094.109.137.131.128.032-.012.07-.087.115-.223-.023-.593.355-.986.378-1.384z"
            />
            <path
              fill="#ffe000"
              d="M15.325 15.394l.183-.086c.18.375.09.763-.258 1.149l-.151-.132c.151-.442.151-.625.226-.931z"
            />
            <path
              fill="#027934"
              fillRule="nonzero"
              d="M15.091 15.382l.191-.056c.092.314.046.637-.134.966l-.174-.096c.156-.284.194-.554.117-.814z"
            />
            <g fillRule="nonzero">
              <path fill="#864c26" d="M19.554 9.96l-.036-.036-7.22 6.945.036.035z" />
              <path fill="#864c26" d="M11.779 16.417l.03.04 8.4-6.17-.031-.04z" />
              <path fill="#a05a2c" d="M11.602 15.802l.025.043 9.343-5.086-.025-.043z" />
              <path
                fill="#e7e7e7"
                d="M22 10.184l-.805.27.232.268zm-.767.073l-.115.104c-.183.166-.24.304-.162.412.077.106.236.126.475.068l.097-.024-.097-.024a.62.62 0 01-.195-.082l.04-.001c.05 0 .092-.033.124-.095l.03.034.368-.345-.515.173h.002l-.033.008a1.682 1.682 0 00-.083.023.108.108 0 00-.053.032.276.276 0 01.042-.15zm.014-.616l-.778.338.036.034a1.78 1.78 0 00-.058.022.108.108 0 00-.049.036.27.27 0 01.028-.151l.063-.14-.106.113c-.167.182-.212.325-.125.425.086.099.247.105.48.026l.094-.032-.099-.016a.619.619 0 01-.202-.065l.041-.004c.036-.003.066-.023.09-.058l.06.058zm-.849-.529l-.707.468.04.027-.05.03a.107.107 0 00-.043.046.282.282 0 01.002-.156l.037-.15-.084.131c-.134.208-.153.356-.05.44.102.082.261.061.476-.057l.088-.048-.1.001a.62.62 0 01-.21-.028l.04-.012a.119.119 0 00.077-.07l.07.046z"
              />
            </g>
            <g transform="matrix(-1 0 0 1 21.073 9.935)">
              <path fill="#925229" d="M2.544 6.278l.835-1.489 1.17.315-.842 1.36H3.38v.147z" />
              <path
                fill="#ffe000"
                d="M2.186.553l-.552.575-.201 3.794 1.99.29c-.578-.508-.91-.918-.995-1.232-.128-.47-.168-2.225.074-2.492l.189.11.152-.45"
              />
              <path
                fill="#d52c1e"
                d="M.262.812C.12 2.787.048 3.948.048 4.295c0 .52.442 1.76 1.449 1.76s2.389-.555 2.389-.781c0-.15-.138-.28-.413-.388-1.234.084-1.852-.113-1.852-.591 0-.717.126-2.841.236-3.092.073-.166.237-.376.491-.628l-.727-.54-.124.54-.466-.158-.142.786z"
              />
              <path
                fill="#027934"
                d="M2.85 1.14l-.134.42-.27-.114c-.27 1.264-.27 2.16 0 2.69.269.53.743.814 1.422.852l-.43-3.428z"
              />
              <path
                fill="#e8a30c"
                d="M2.79 3.703l-.97.767c-.178.255-.178.478 0 .67.266.29 1.004.584 1.178.235.116-.232.346-.484.691-.757z"
              />
              <circle cx="3.389" cy=".619" r="1" fill="#e1e5e8" transform="rotate(-41 3.389 .62)" />
            </g>
            <path
              fill="#d52c1e"
              d="M16.03 15.378l.51-.005c.377.374.412.877.114 1.484-.065.094-.109.137-.131.128-.032-.012-.07-.087-.115-.223.023-.593-.355-.986-.378-1.384z"
            />
            <path
              fill="#ffe000"
              d="M16.675 15.394l-.183-.086c-.18.375-.09.763.258 1.149l.151-.132c-.151-.442-.151-.625-.226-.931z"
            />
            <path
              fill="#027934"
              fillRule="nonzero"
              d="M16.909 15.382l-.191-.056c-.092.314-.046.637.134.966l.174-.096c-.156-.284-.194-.554-.117-.814z"
            />
            <path
              fill="#00a6de"
              fillRule="nonzero"
              d="M15.974 14.91c1.024 0 1.854-.935 1.854-2.09s-.83-2.089-1.854-2.089-1.854.936-1.854 2.09.83 2.09 1.854 2.09zm0 .548c-1.358 0-2.42-1.198-2.42-2.637s1.062-2.637 2.42-2.637 2.42 1.198 2.42 2.637-1.062 2.637-2.42 2.637z"
            />
            <g transform="translate(14.12 10.731)">
              <use fill="#ffc036" xlinkHref="#mantine-u8fps9l1o" />
              <path
                fill="#d52c1e"
                d="M1.854 1.716l-.24.497.005-.548-.44.346.252-.491-.551.127.447-.337-.554-.116.554-.116L.88.74l.551.127-.251-.49.44.345-.007-.548.241.497.24-.497-.005.548.44-.346-.252.491.552-.127-.448.337.555.116-.555.116.448.337-.552-.127.251.49-.44-.345.007.548z"
                mask="url(#mantine-bufyciiu3)"
              />
              <path
                fill="#027934"
                d="M-.079 2.21c.967-.68 1.569-1.021 1.806-1.021.356 0 1.876 1.026 2.187 1.166.207.093.207 1.052 0 2.878H-.2z"
                mask="url(#mantine-bufyciiu3)"
              />
            </g>
            <path
              fill="#ffc036"
              fillRule="nonzero"
              d="M15.991 10.442c.892.05 1.56.537 2 1.455l-.094.041c-.424-.886-1.06-1.349-1.909-1.396-.758 0-1.38.409-1.868 1.233l-.09-.05c.506-.853 1.16-1.283 1.961-1.283z"
            />
            <g transform="translate(12.678 7)">
              <path
                fill="#036a2d"
                fillRule="nonzero"
                d="M2.005.007l.199.145c-.51.457-.605.966-.508 1.404.102.457.554.943 1.375 1.443l-.302.463c-.938-.57-1.478-1.099-1.618-1.728-.144-.647.21-1.149.854-1.727zm2.703 0L4.51.152c.51.457.605.966.507 1.404-.101.457-.553.943-1.374 1.443l.302.463c.938-.57 1.478-1.099 1.618-1.728.144-.647-.21-1.149-.855-1.727z"
              />
              <path
                fill="#452c24"
                d="M.097 1.862c.58-.401 1.007-.602 1.282-.602.412 0 .963-.137 1.05.179.086.316.249.225.568.225h.948c-.125-.27-.072-.404.16-.404.347 0 1.799.206 2.237.404.292.132.445.237.46.314a1.095 1.095 0 00-.854-.116c-.448.116-1.262.632-1.633.632-.247 0-.469.132-.667.398.017-.136-.088-.17-.313-.102-.338.102-.33.582-.618.494-.289-.088.083-.79 0-.79-.056 0-.28-.077-.672-.231-.381-.346-.855-.48-1.42-.401-.566.077-.742.077-.528 0z"
              />
              <circle cx="3.193" cy="2.015" r="1" fill="#e7e7e7" />
              <path
                fill="#e8a30c"
                d="M2.526 2.007c.066-.126.166-.189.298-.189.198 0 .569 0 .569.095 0 .094.03.218-.27.218s-.107-.124-.3-.124h-.297z"
              />
            </g>
            <path
              fill="#e1e5e8"
              d="M18.736 10.283c.077-.08.137-.218.18-.413-.343.055-.554.055-.634 0-.08-.054-.14-.162-.182-.323-.309.141-.404.212-.286.212.117 0 .213.052.286.156l.36.133c-.16.157-.2.235-.12.235.12 0 .281.121.396 0z"
            />
            <path
              fill="#925229"
              fillRule="nonzero"
              d="M17.83 10.384l-.064-.078.452-.353.064.077z"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
}
